import { render, staticRenderFns } from "./Status_Fail.vue?vue&type=template&id=ecefafbc&scoped=true"
import script from "./Status_Fail.vue?vue&type=script&lang=js"
export * from "./Status_Fail.vue?vue&type=script&lang=js"
import style0 from "./Status_Fail.vue?vue&type=style&index=0&id=ecefafbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecefafbc",
  null
  
)

export default component.exports